/**
 * @flow
 */
import React from "react";
import {Card, Checkbox, FormControlLabel, Grid, Button, withStyles, CircularProgress} from '@material-ui/core'
import {ValidatorForm, TextValidator} from "react-material-ui-form-validator";
import {useDispatch, useSelector} from 'react-redux'
import {signUp} from '../../redux/actions/actions'
import {ROUTE} from '../../settings'
import Nav from '../../services/Nav'
import {openAlertError} from '../../redux/reducers/modalReducer';
import postingPhoto from '../../media/posting_photo.svg';

function useSignUp() {
  const [displayName, setDisplayName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [agreement, setAgreement] = React.useState(false);
  const dispatch = useDispatch();
  const signUpState = useSelector((state) => state['signUp']);
  const onDisplayNameChange = ({target: {value}}) => setDisplayName(value);
  const onEmailChange = ({target: {value}}) => setEmail(value);
  const onPasswordChange = ({target: {value}}) => setPassword(value);
  const onAgreementChange = (e, checked) => setAgreement(checked);
  const onSubmit = async (e) => {
    try {
      await signUp(dispatch, {displayName, loginId: email, pwd: password});
    } catch(error) {
      openAlertError(dispatch, error);
    }
  };
  return [
    displayName, email, password, agreement, signUpState.status === 'pending',
    onDisplayNameChange, onEmailChange, onPasswordChange, onAgreementChange, onSubmit
  ];
}

const SignUp = ({classes}) => {
  const [
    displayName, email, password, agreement, pending,
    onDisplayNameChange, onEmailChange, onPasswordChange, onAgreementChange, onSubmit
  ] = useSignUp();
  const formRef = React.useRef();
  return (
    <div className="signup flex flex-center w-100 h-100vh">
      <div className="p-8">
        <Card className="signup-card position-relative y-center">
          <Grid container>
            <Grid item lg={5} md={5} sm={5} xs={12}>
              <div className="p-32 flex flex-center bg-light-gray flex-middle h-100">
                {/*<img src={process.env.NODE_ENV === 'production' ? '/dboard/assets/images/illustrations/posting_photo.svg' : '/assets/images/illustrations/posting_photo.svg'} alt="" />*/}
                <img src={postingPhoto} alt={'left'} />
              </div>
            </Grid>
            <Grid item lg={7} md={7} sm={7} xs={12}>
              <div className="p-36 h-100">
                <ValidatorForm ref={formRef} onSubmit={onSubmit}>
                  <TextValidator
                    className="mb-24 w-100"
                    variant="outlined"
                    label="Username"
                    onChange={onDisplayNameChange}
                    type="text"
                    name="username"
                    value={displayName}
                    validators={["required"]}
                    errorMessages={["this field is required"]}
                  />
                  <TextValidator
                    className="mb-24 w-100"
                    variant="outlined"
                    label="Email"
                    onChange={onEmailChange}
                    type="email"
                    name="email"
                    value={email}
                    validators={["required", "isEmail"]}
                    errorMessages={[
                      "this field is required",
                      "email is not valid"
                    ]}
                  />
                  <TextValidator
                    className="mb-16 w-100"
                    label="Password"
                    variant="outlined"
                    onChange={onPasswordChange}
                    name="password"
                    type="password"
                    value={password}
                    validators={["required"]}
                    errorMessages={["this field is required"]}
                  />
                  <FormControlLabel
                    className="mb-16"
                    name="agreement"
                    onChange={onAgreementChange}
                    control={<Checkbox checked={agreement} />}
                    label="I have read and agree to the terms of service."
                  />
                  <div className="flex flex-middle">
                    <div className={classes.wrapper}>
                      <Button
                        className="capitalize"
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={pending}
                      >
                        Sign up
                      </Button>
                      {pending && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </div>
                    <span className="ml-16 mr-8">or</span>
                    <Button
                      className="capitalize"
                      disabled={pending}
                      onClick={() => Nav.push(ROUTE.SIGN_IN)}
                    >
                      Sign in
                    </Button>
                  </div>
                </ValidatorForm>
              </div>
            </Grid>
          </Grid>
        </Card>
      </div>
    </div>
  );
}

const styles = theme => ({
  wrapper: {
    position: "relative"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
});

export default withStyles(styles, {withTheme: true})(SignUp);
